import React, { useState , useRef } from "react";
import "./Sealingexteriorwalls.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר

export default function Sealingexteriorwalls() {


  return (

    <div className="Roofrepair-page">
      <div className="Roofrepair-hero">
        <div className="Roofrepair-overlay">
          <h1>   איטום קירות חיצוניים</h1>
        </div>
<div>
</div>
</div>
    <div className="page4">
 <div className="breadcrumb4">
  <Link to="/">בית</Link> /{" "}
  <Link to="/ProfessionalInformation"> מידע מקצועי</Link>/{" "}
   <Link to="/Sealingexteriorwalls">   איטום קירות חיצוניים</Link>{" "}
</div>
    </div>
<div className="video-box">
  <iframe
    width="100%"
    height="400"
    src="https://www.youtube.com/embed/pBMChywUfGc?start=11"
    title="YouTube video"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowFullScreen
  ></iframe>
</div>
      {/* CONTENT */}
<div className="page4">
  <div className="container">
<p>
כדי שמבנה יהיה אטום היטב, מוגן מפני דליפות של מי גשמים ושומר על הטמפרטורה היציבה בכל עונות השנה, חשוב מאוד כי הוא יהיה אטום. יש כאלה הסבורים כי חשיבות האיטום היא רק בגג כיוון שמשם עשויה להיות דליפה של מי גשמים. לא כולם יודעים כי כאשר הקירות אינם אטומים, 

הבית חשוף מאוד לפגעי מזג האוויר שלא לומר נזילות המובילות לנזקים למבנה, לעובש וכדומה. בדיוק לשם כך יש צורך לבצע איטום קירות חיצוניים.


</p>


    <div className="content-row">


      <div className="image-box">
        <img src="/images/35.jpeg" alt="roof" />
      </div>
      <div className="text-box">
        <p>  איטום גגות וקירות החיצוניים חשוב מאוד לכל מבנה. כאשר אנחנו משקיעים באיטום, אנחנו נהנים ממבנה מוגן, ממבנה אשר לא יהיה חשוף לדליפות של מי גשמים או אפילו חדירה של קור או חום בחודשים אשר בהם מזג האוויר הוא קיצוני.

אז אם מדובר במבנה נמוך של בית חד קומתי, הבעיה אינה מסובכת כל כך. ניתן בקלות לבצע את המלאכה באמצעים רגילים הנמצאים ברשות כל קבלן איטום או אפילו בכל בית כמו בעזרת סולם  או אפילו פיגום נייד. אך מה עושים כאשר מדובר במבנה גבוה?

אז אם עד לא מזמן הדרך להגיע אל החלקים החיצוניים בבניינים רבי קומות הייתה על ידי מנוף, הרי שכיום יש לנו את האמצעים הפשוטים והקלילים הרבה יותר. ניתן היום לבצע את העבודה בעזרת סנפלינג. ציוד לא מורכב ולא ממש מערכתי והעבודה נעשית במהירות ביעילות ועם צוות קטן ואפקטיבי.</p>
      </div>

    </div>

    <h2 className="main-title">
איטום קירות חיצוניים באמצעות סנפלינג
    </h2>
    <div className="bottom-text">
      <p> אז איך זה למעשה נעשה בפועל? את הסנפלינג כולנו או לפחות רובנו מכירים בכלל מתחום ההרפתקאות והאקשן. גלישה בסנפלינג זוהי חוויה אטרקטיבית ויש שיאמרו מפוקפקת (אלו הסובלים מפחד גבהים) אך אלו שמתחברים לעולם הזה ונהנים מריגושים מן הסוג הזה, עשויים ליהנות מאוד מעבודה בתחום.
הם למעשה משלבים את העבודה שלהם בתוך חוויה מדהימה שעבורם היא מאתגרת וחווייתית במיוחד. </p>
    <h2 className="main-title">
עבודה בין שמים וארץ, אז איך זה בעצם מתבצע?
    </h2>

      <p>   כאשר אנחנו באים לבצע עבורכם עבודות סנפלינג, אנחנו מביאים אתנו ציוד בטוח לשימוש, ציוד איכותי, ציוד נוח שניתן יהיה לבצע את העבודה באופן הכי בטוח והכי קל ומהיר.
הציוד ירד מהגג עם העובד המסור שיתחיל במלאכתו. הוא יבצע אותה באופן יסודי ומקצועי כאשר תוך זמן קצר המלאכה תושלם. בלי הרבה בלגן, בלי הרבה פרוצדורה היות ואין כאן את השינוע של כלים כבדים כמו מנופים וכדומה. </p>
 <h2 className="main-title">
* כיסוי ביטוחי מלא לכל עבודה




    </h2>
    </div>


    <ContactSection2/>
<div className="links">


  <Link to="/Roofrepair" className="link-right" >תיקון גגות</Link>
  <Link to="/BuildingRehabilitation" className="link-left" >שיקום מבנים</Link>


</div>

      </div>
    </div>
  

      </div>
  );
}

